import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-left'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Container, SloganHeader } from './styles'
import LoginForm from '../../components/LoginForm/LoginForm'
import images from '../../config/images'
import Avatar from '../../components/Avatar/Avatar'
import FooterMenu from '../../components/FooterMenu'
import ForgotPassword from '../../components/ForgotPassword'
import { checkJapanese } from '../../lib/index'

const hasLogin = pathname => {
  const substr = 'login'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

const hasForgotPassword = pathname => {
  const substr = 'forgot-password'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

class Login extends Component {

  constructor (props) {
    super(props)
    var update_flag = true
    if (!((/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) || /Firefox/.test(navigator.userAgent) || /Safari/.test(navigator.userAgent)))) {
      checkJapanese() ? alert('PC の Google Chrome を使用してください') : alert('You have to use PC\'s Google Chrome');
      window.location = 'https://www.google.com/chrome/browser/desktop/index.html'
      update_flag = false
      return
    }
  }

  componentWillUnmount () {
    this.props.authErrors(null)
  }

  render () {
    const textColor = '#000000'
    return (
      <div className="flex justify-center flex-column items-center h-100">
        <div>
          <div className="mt3 mb4 tc">
            <SloganHeader className="mb3" textColor={textColor}>
              <FormattedMessage id="login.title" />
            </SloganHeader>
          </div>
          <div className="inline-flex items-center login-form">
            {hasForgotPassword(this.props.location) ? (
              <div className="mr4">
                <Link
                  to={'/login'}
                >
                  <FloatingActionButton>
                    <Arrow/>
                  </FloatingActionButton>
                </Link>
              </div>
            ) : (
              ''
            )}
            <Container
              className={hasForgotPassword(this.props.location) ? 'mr6' : ''}
            >
              <Paper zDepth={3}>
                <div className={`login-layout ${!this.props.shouldResetPassword ? 'pa4' : ''}`}>
                  {hasLogin(this.props.location) &&
                  this.props.errors &&
                  this.props.errors.length >= 1 ? (
                    <div className="tc red">
                      <p>
                        {this.props.errors ===
                        'translation missing: en.invalid_password' ? (
                          <FormattedMessage id="login.invalidPassword"/>
                        ) : this.props.errors ===
                        'translation missing: en.user_not_found' ? (
                          <FormattedMessage id="login.noUser"/>
                        ) : this.props.errors ===
                        'ip_address_not_allowed' ? (
                          <FormattedMessage id="login.invalid_ip"/>
                        ) : this.props.errors ===
                        'Invalid email/password combination' ? (
                          <FormattedMessage id="login.invalidPassword"/>
                        ) : (
                          this.props.errors
                        )}
                      </p>       
                    </div>
                  ) : (
                    ''
                  )}
                  {hasLogin(this.props.location) && this.props.maxAttempt &&<div className="tc red">  <p><FormattedMessage id="login.maxAttemptExceed"/></p> </div>}
                  {hasLogin(this.props.location) ? (
                    <div>
                      <Avatar src={images.avatar}/>
                      <LoginForm
                        user={this.props.user}
                        authErrors={this.props.authErrors}
                        location={this.props.location}
                        loginUser={this.props.loginUser}
                        logoutRequestResult={this.props.logoutRequestResult}
                        loginStatus={this.props.loginStatus}
                        shouldRedirectUser={this.props.shouldRedirectUser}
                        resetLoginAttempt={this.props.resetLoginAttempt}
                        resetError={this.props.resetError}
                        shouldRedirectUserToLogin={
                          this.props.shouldRedirectUserToLogin
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      {this.props.forgetPassError ? (
                        <div className="tc red">
                          <FormattedMessage id="login.emailNotFound"/>
                        </div>
                      ) : (
                        ''
                      )}
                      <ForgotPassword
                        resetPassword={this.props.resetPassword}
                        location={this.props.location}
                        forgetPassError={this.props.forgetPassError}
                        shouldResetPassword={this.props.shouldResetPassword}
                        setShouldResetPassword={
                          this.props.setShouldResetPassword
                        }
                      />
                    </div>
                  )}
                </div>
              </Paper>
              <FooterMenu/>
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

export default Login




// WEBPACK FOOTER //
// src/routes/Login/Login.js